import { ArrowDownLeft, ArrowUpRight, CalendarClock, GitBranch, Mail, MessageCircle, MessageSquare, Pencil, Phone, Smartphone, Tag } from "lucide-react";

export const TYPE_META = {
  call: { label: "Appel", icon: Phone, color: "#2563eb" },
  email: { label: "E-mail", icon: Mail, color: "#7c3aed" },
  sms: { label: "SMS", icon: Smartphone, color: "#0891b2" },
  whatsapp: { label: "WhatsApp", icon: MessageCircle, color: "#16a34a" },
  comment: { label: "Commentaire", icon: MessageSquare, color: "#e8603c" },
  stage_change: { label: "Étape", icon: GitBranch, color: "#ca8a04" },
  field_update: { label: "Champ", icon: Pencil, color: "#64748b" },
  tag_change: { label: "Tag", icon: Tag, color: "#db2777" },
  next_action: { label: "Relance", icon: CalendarClock, color: "#0d9488" },
};

export const PERIODS = [["today", "Aujourd'hui"], ["yesterday", "Hier"], ["this_week", "Semaine"], ["last_week", "Sem. dernière"], ["this_month", "Mois"], ["last_month", "Mois dernier"], ["custom", "Personnalisé"]];

export const TypeIcon = ({ type, size = 14 }) => {
  const meta = TYPE_META[type] || TYPE_META.field_update;
  const Icon = meta.icon;
  return <span className="ck-type" style={{ "--c": meta.color }} title={meta.label}><Icon size={size} /></span>;
};

export const DirIcon = ({ direction }) => (direction === "inbound" ? <ArrowDownLeft size={12} className="ck-dir in" /> : direction === "outbound" ? <ArrowUpRight size={12} className="ck-dir out" /> : null);

export const time = (iso) => new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
export const dateTime = (iso) => new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
